import React from 'react';
import { View, Modal, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';
import { useAdminColors } from '@/hooks/admin/useAdminColors';
import { GlassCard } from '@/components/shared/redesign';
import { Button } from '@/components/common/admin/mobile/Button';
import { SVG_COMPONENTS } from '@/assets/admin';

interface CreateUserSuccessModalProps {
  visible: boolean;
  onClose: () => void;
  userName: string;
}

export const CreateUserSuccessModal: React.FC<CreateUserSuccessModalProps> = ({
  visible,
  onClose,
  userName,
}) => {
  const styles = useStyles();
  const { semantic, redesign } = useAdminColors();

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <GlassCard
          style={[styles.modal, { backgroundColor: redesign.bg.modal }]}
          padding={24}
        >
          {/* Success Icon */}
          <View style={styles.iconContainer}>
            <SVG_COMPONENTS.CHECK_CIRCLE
              width={64}
              height={64}
              color={semantic.status.success}
            />
          </View>

          {/* Success Message */}
          <View style={styles.content}>
            <Text style={styles.title}>User Successfully Created!</Text>
            <Text style={styles.message}>
              {userName} has been added to the system. You can view or edit the user at any time.
            </Text>
          </View>

          {/* Close Button */}
          <Button title="Done" onPress={onClose} variant="primary" style={styles.closeButton} />
        </GlassCard>
      </View>
    </Modal>
  );
};

const useStyles = () =>
  useThemedStyles(({ components, colors }) =>
    StyleSheet.create({
      overlay: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 20,
      },
      modal: {
        alignItems: 'center',
        maxWidth: 320,
        width: '100%',
      },
      iconContainer: {
        marginBottom: 20,
      },
      content: {
        alignItems: 'center',
        marginBottom: 24,
      },
      title: {
        fontSize: 20,
        fontWeight: '600',
        color: colors.text.primary,
        textAlign: 'center',
        marginBottom: 12,
      },
      message: {
        fontSize: 14,
        color: components.admin.dataCell.textMuted,
        textAlign: 'center',
        lineHeight: 20,
      },
      closeButton: {
        minWidth: 120,
      },
    }),
  );
